<form [formGroup]="form" class="row">
    <!-- Caso Validacion Referencia  -->
    <div class="col-12 row" >
       <div class="col-12">
        <mat-form-field style="width: 100%;" appearance="outline" >
            <mat-label>Descripción de la Validación Realizada</mat-label>
            <textarea matInput placeholder="Describa la validación realizada" formControlName="descripcion" ></textarea>
        </mat-form-field>
       </div>
          <div class="separador col-12"></div>
          <div class="divSelector col-6">
            <p class="inputRadio">Enviada Respuesta a Solicitante</p>
           <mat-radio-group class="checleft" formControlName="enviada" aria-label="Select an option">
               <mat-radio-button value="Si">Si</mat-radio-button>
               <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
             </mat-radio-group>
        </div>
        <div class="col-6">
            <mat-form-field appearance="outline" class="dateInput">
                <mat-label>Fecha de Envio</mat-label>
                <input matInput formControlName="fecha" [matDatepicker]="picker" />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <!-- <mat-error *ngIf="form.get('fecha').hasError('required')"
                  >La fecha es <strong>requerida </strong></mat-error
                > -->
              </mat-form-field>
        </div>
        
     </div>
</form>
